<div *ngIf="isLoading">
  <po-loading-overlay [p-text]="text" [p-size]="size"></po-loading-overlay>
</div>

<po-page-default p-title="Movimentação de OP por contagem">

  <div class="po-row po-mb-2 po-mt-2">
    <div class="po-xl-12 po-text-right">
      <po-button p-label="Sair" p-kind="secondary" (p-click)="goBack()"></po-button>
    </div>
  </div>

  <div class="po-row po-mb-2 po-mt-2">
    <div
      [ngClass]="countDetails.pack > 0 ? 'po-xs-4 po-sm-4 po-md-4 po-lg-4 po-xl-4' : 'po-xs-6 po-sm-6 po-md-6 po-lg-6 po-xl-6'">
      <po-info class="po-info-vertical" p-label="Contagem" [p-value]="countDetails.code"></po-info>
    </div>

    <div
      [ngClass]="countDetails.pack > 0 ? 'po-xs-4 po-sm-4 po-md-4 po-lg-4 po-xl-4' : 'po-xs-6 po-sm-6 po-md-6 po-lg-6 po-xl-6'">
      <po-info class="po-info-vertical" p-label="Quantidade" [p-value]="countDetails.quantity + ''"></po-info>
    </div>

    <div class="po-xs-4 po-sm-4 po-md-4 po-lg-4 po-xl-4" *ngIf="countDetails.pack > 0">
      <po-info class="po-info-vertical" p-label="Packs" [p-value]="countDetails.pack + ''"></po-info>
    </div>
  </div>

  <hr class="hr-divider">
  <div class="po-mb-2">
    <po-combo p-icon="an an-building-office" p-label="Local de origem" name="originLocation"
      [ngModel]="countDetails.originLocation" (ngModelChange)="onOriginLocationChange($event)"
      [p-options]="allLocations" p-field-label="displayLabel" p-field-value="placeCode" p-filter-min-length="0"
      [p-filter-mode]="filterMode" [p-disabled]="countDetails.quantity > 0">
    </po-combo>
  </div>
  <div class="po-mb-2">
    <po-combo p-icon="an an-building-office" p-label="Local de destino" name="destinationLocation"
      [ngModel]="countDetails.destinationLocation" (ngModelChange)="onDestinationLocationChange($event)"
      [p-options]="allLocations" p-field-label="displayLabel" p-field-value="placeCode" p-filter-min-length="0"
      [p-filter-mode]="filterMode" [p-disabled]="countDetails.quantity > 0">
    </po-combo>
  </div>

  <div class="po-row po-mb-2">
    <div class="po-xl-12 po-text-right">
      <po-button p-label="Limpar" p-kind="secondary" (p-click)="clearFields()"
      [p-disabled]="countDetails.quantity > 0"></po-button>
    </div>
  </div>

  



  <div class="po-xs-12 po-sm-12 po-md-12 po-lg-12 po-xl-12 po-mb-1">
    <hr class="hr-divider">
    <po-button p-label="Itens" (p-click)="showItems()" class="po-mt-1 po-xl-2 po-lg-4 po-md-12 po-sm-12 po-text-center"
      [p-disabled]="!isLocationSelectionValid ">
    </po-button>
  </div>


  <div class="po-xs-12 po-sm-12 po-md-12 po-lg-12 po-xl-12 po-mb-3">
    <hr class="hr-divider">
    <po-button p-label="Movimentar OP" (p-click)="moveOp('PCPAPP001')"
      class="po-mt-1 po-xl-2 po-lg-4 po-md-12 po-sm-12 po-text-center"
      [p-disabled]="!isLocationSelectionValid || isOPFinished || countDetails.quantity < 1">
    </po-button>

  </div>
</po-page-default>
<app-toaster></app-toaster>